import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineCommentAltIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M19 2H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h11.59l3.7 3.71A1.0003 1.0003 0 0 0 21 22a.8395.8395 0 0 0 .38-.08A1.0004 1.0004 0 0 0 22 21V5a3 3 0 0 0-3-3Zm1 16.59-2.29-2.3A1.0003 1.0003 0 0 0 17 16H5a1.0002 1.0002 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v13.59Z"/>
  </SvgIcon>
}

export default LineCommentAltIcon
